// @ts-nocheck

import * as Apollo from "@apollo/client";

import gql from "graphql-tag";
import * as APITypes from "../../apiTypes";
import { ChatChannelFragmentDoc, ChatMessageFragmentDoc } from "./fragments.generated";

const defaultOptions = {} as const;
export type GetChatChannelByIdQueryVariables = APITypes.Exact<{
  channelId: APITypes.Scalars["String"]["input"];
}>;

export type GetChatChannelByIdQuery = {
  getChatChannelById: {
    hasUnreadMessages: boolean;
    id: string;
    state: APITypes.ChannelState;
    messages?: Array<{
      attachments?: Array<string> | null;
      content: string;
      createdAt: string;
      id: string;
      state: APITypes.MessageState;
      author?: { avatar?: string | null; name: string; profileId?: string | null } | null;
    }> | null;
    order: { id: string };
    participants: Array<{ avatar?: string | null; name: string; profileId?: string | null }>;
  };
};

export type GetChatChannelByOrderIdQueryVariables = APITypes.Exact<{
  orderId: APITypes.Scalars["String"]["input"];
}>;

export type GetChatChannelByOrderIdQuery = {
  getChatChannelByOrderId: {
    hasUnreadMessages: boolean;
    id: string;
    state: APITypes.ChannelState;
    messages?: Array<{
      attachments?: Array<string> | null;
      content: string;
      createdAt: string;
      id: string;
      state: APITypes.MessageState;
      author?: { avatar?: string | null; name: string; profileId?: string | null } | null;
    }> | null;
    order: { id: string };
    participants: Array<{ avatar?: string | null; name: string; profileId?: string | null }>;
  };
};

export type ListChatChannelsQueryVariables = APITypes.Exact<{ [key: string]: never }>;

export type ListChatChannelsQuery = {
  listChatChannels: Array<{
    hasUnreadMessages: boolean;
    id: string;
    state: APITypes.ChannelState;
    messages?: Array<{
      attachments?: Array<string> | null;
      content: string;
      createdAt: string;
      id: string;
      state: APITypes.MessageState;
      author?: { avatar?: string | null; name: string; profileId?: string | null } | null;
    }> | null;
    order: { id: string };
    participants: Array<{ avatar?: string | null; name: string; profileId?: string | null }>;
  }>;
};

export type ListChatChannelsForReservationsQueryVariables = APITypes.Exact<{
  payload: APITypes.ListChatChannelsForReservationsInput;
}>;

export type ListChatChannelsForReservationsQuery = {
  listChatChannelsForReservations: Array<{
    hasUnreadMessages: boolean;
    id: string;
    state: APITypes.ChannelState;
    messages?: Array<{
      attachments?: Array<string> | null;
      content: string;
      createdAt: string;
      id: string;
      state: APITypes.MessageState;
      author?: { avatar?: string | null; name: string; profileId?: string | null } | null;
    }> | null;
    order: { id: string };
    participants: Array<{ avatar?: string | null; name: string; profileId?: string | null }>;
  }>;
};

export type ReadChannelMutationVariables = APITypes.Exact<{
  channelId: APITypes.Scalars["String"]["input"];
}>;

export type ReadChannelMutation = {
  readChannel: {
    hasUnreadMessages: boolean;
    id: string;
    state: APITypes.ChannelState;
    messages?: Array<{
      attachments?: Array<string> | null;
      content: string;
      createdAt: string;
      id: string;
      state: APITypes.MessageState;
      author?: { avatar?: string | null; name: string; profileId?: string | null } | null;
    }> | null;
    order: { id: string };
    participants: Array<{ avatar?: string | null; name: string; profileId?: string | null }>;
  };
};

export type SendMessageMutationVariables = APITypes.Exact<{
  message: APITypes.ChatMessageInput;
}>;

export type SendMessageMutation = {
  sendMessage: {
    attachments?: Array<string> | null;
    content: string;
    createdAt: string;
    id: string;
    state: APITypes.MessageState;
    author?: { avatar?: string | null; name: string; profileId?: string | null } | null;
  };
};

export const GetChatChannelByIdDocument = gql`
    query GetChatChannelById($channelId: String!) {
  getChatChannelById(channelId: $channelId) {
    ...ChatChannel
  }
}
    ${ChatChannelFragmentDoc}`;

/**
 * __useGetChatChannelByIdQuery__
 *
 * To run a query within a React component, call `useGetChatChannelByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatChannelByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatChannelByIdQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetChatChannelByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetChatChannelByIdQuery, GetChatChannelByIdQueryVariables> &
    ({ variables: GetChatChannelByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChatChannelByIdQuery, GetChatChannelByIdQueryVariables>(
    GetChatChannelByIdDocument,
    options,
  );
}
export function useGetChatChannelByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChatChannelByIdQuery,
    GetChatChannelByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetChatChannelByIdQuery, GetChatChannelByIdQueryVariables>(
    GetChatChannelByIdDocument,
    options,
  );
}
export function useGetChatChannelByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChatChannelByIdQuery, GetChatChannelByIdQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetChatChannelByIdQuery, GetChatChannelByIdQueryVariables>(
    GetChatChannelByIdDocument,
    options,
  );
}
export type GetChatChannelByIdQueryHookResult = ReturnType<typeof useGetChatChannelByIdQuery>;
export type GetChatChannelByIdLazyQueryHookResult = ReturnType<
  typeof useGetChatChannelByIdLazyQuery
>;
export type GetChatChannelByIdSuspenseQueryHookResult = ReturnType<
  typeof useGetChatChannelByIdSuspenseQuery
>;
export type GetChatChannelByIdQueryResult = Apollo.QueryResult<
  GetChatChannelByIdQuery,
  GetChatChannelByIdQueryVariables
>;
export const GetChatChannelByOrderIdDocument = gql`
    query GetChatChannelByOrderId($orderId: String!) {
  getChatChannelByOrderId(orderId: $orderId) {
    ...ChatChannel
  }
}
    ${ChatChannelFragmentDoc}`;

/**
 * __useGetChatChannelByOrderIdQuery__
 *
 * To run a query within a React component, call `useGetChatChannelByOrderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatChannelByOrderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatChannelByOrderIdQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetChatChannelByOrderIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChatChannelByOrderIdQuery,
    GetChatChannelByOrderIdQueryVariables
  > &
    ({ variables: GetChatChannelByOrderIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChatChannelByOrderIdQuery, GetChatChannelByOrderIdQueryVariables>(
    GetChatChannelByOrderIdDocument,
    options,
  );
}
export function useGetChatChannelByOrderIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChatChannelByOrderIdQuery,
    GetChatChannelByOrderIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetChatChannelByOrderIdQuery, GetChatChannelByOrderIdQueryVariables>(
    GetChatChannelByOrderIdDocument,
    options,
  );
}
export function useGetChatChannelByOrderIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetChatChannelByOrderIdQuery,
        GetChatChannelByOrderIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetChatChannelByOrderIdQuery,
    GetChatChannelByOrderIdQueryVariables
  >(GetChatChannelByOrderIdDocument, options);
}
export type GetChatChannelByOrderIdQueryHookResult = ReturnType<
  typeof useGetChatChannelByOrderIdQuery
>;
export type GetChatChannelByOrderIdLazyQueryHookResult = ReturnType<
  typeof useGetChatChannelByOrderIdLazyQuery
>;
export type GetChatChannelByOrderIdSuspenseQueryHookResult = ReturnType<
  typeof useGetChatChannelByOrderIdSuspenseQuery
>;
export type GetChatChannelByOrderIdQueryResult = Apollo.QueryResult<
  GetChatChannelByOrderIdQuery,
  GetChatChannelByOrderIdQueryVariables
>;
export const ListChatChannelsDocument = gql`
    query ListChatChannels {
  listChatChannels {
    ...ChatChannel
  }
}
    ${ChatChannelFragmentDoc}`;

/**
 * __useListChatChannelsQuery__
 *
 * To run a query within a React component, call `useListChatChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListChatChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListChatChannelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListChatChannelsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListChatChannelsQuery, ListChatChannelsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListChatChannelsQuery, ListChatChannelsQueryVariables>(
    ListChatChannelsDocument,
    options,
  );
}
export function useListChatChannelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListChatChannelsQuery, ListChatChannelsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListChatChannelsQuery, ListChatChannelsQueryVariables>(
    ListChatChannelsDocument,
    options,
  );
}
export function useListChatChannelsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListChatChannelsQuery, ListChatChannelsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListChatChannelsQuery, ListChatChannelsQueryVariables>(
    ListChatChannelsDocument,
    options,
  );
}
export type ListChatChannelsQueryHookResult = ReturnType<typeof useListChatChannelsQuery>;
export type ListChatChannelsLazyQueryHookResult = ReturnType<typeof useListChatChannelsLazyQuery>;
export type ListChatChannelsSuspenseQueryHookResult = ReturnType<
  typeof useListChatChannelsSuspenseQuery
>;
export type ListChatChannelsQueryResult = Apollo.QueryResult<
  ListChatChannelsQuery,
  ListChatChannelsQueryVariables
>;
export const ListChatChannelsForReservationsDocument = gql`
    query ListChatChannelsForReservations($payload: ListChatChannelsForReservationsInput!) {
  listChatChannelsForReservations(payload: $payload) {
    ...ChatChannel
  }
}
    ${ChatChannelFragmentDoc}`;

/**
 * __useListChatChannelsForReservationsQuery__
 *
 * To run a query within a React component, call `useListChatChannelsForReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListChatChannelsForReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListChatChannelsForReservationsQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useListChatChannelsForReservationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListChatChannelsForReservationsQuery,
    ListChatChannelsForReservationsQueryVariables
  > &
    (
      | { variables: ListChatChannelsForReservationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListChatChannelsForReservationsQuery,
    ListChatChannelsForReservationsQueryVariables
  >(ListChatChannelsForReservationsDocument, options);
}
export function useListChatChannelsForReservationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListChatChannelsForReservationsQuery,
    ListChatChannelsForReservationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListChatChannelsForReservationsQuery,
    ListChatChannelsForReservationsQueryVariables
  >(ListChatChannelsForReservationsDocument, options);
}
export function useListChatChannelsForReservationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListChatChannelsForReservationsQuery,
        ListChatChannelsForReservationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListChatChannelsForReservationsQuery,
    ListChatChannelsForReservationsQueryVariables
  >(ListChatChannelsForReservationsDocument, options);
}
export type ListChatChannelsForReservationsQueryHookResult = ReturnType<
  typeof useListChatChannelsForReservationsQuery
>;
export type ListChatChannelsForReservationsLazyQueryHookResult = ReturnType<
  typeof useListChatChannelsForReservationsLazyQuery
>;
export type ListChatChannelsForReservationsSuspenseQueryHookResult = ReturnType<
  typeof useListChatChannelsForReservationsSuspenseQuery
>;
export type ListChatChannelsForReservationsQueryResult = Apollo.QueryResult<
  ListChatChannelsForReservationsQuery,
  ListChatChannelsForReservationsQueryVariables
>;
export const ReadChannelDocument = gql`
    mutation ReadChannel($channelId: String!) {
  readChannel(channelId: $channelId) {
    ...ChatChannel
  }
}
    ${ChatChannelFragmentDoc}`;
export type ReadChannelMutationFn = Apollo.MutationFunction<
  ReadChannelMutation,
  ReadChannelMutationVariables
>;

/**
 * __useReadChannelMutation__
 *
 * To run a mutation, you first call `useReadChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readChannelMutation, { data, loading, error }] = useReadChannelMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useReadChannelMutation(
  baseOptions?: Apollo.MutationHookOptions<ReadChannelMutation, ReadChannelMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ReadChannelMutation, ReadChannelMutationVariables>(
    ReadChannelDocument,
    options,
  );
}
export type ReadChannelMutationHookResult = ReturnType<typeof useReadChannelMutation>;
export type ReadChannelMutationResult = Apollo.MutationResult<ReadChannelMutation>;
export type ReadChannelMutationOptions = Apollo.BaseMutationOptions<
  ReadChannelMutation,
  ReadChannelMutationVariables
>;
export const SendMessageDocument = gql`
    mutation SendMessage($message: ChatMessageInput!) {
  sendMessage(message: $message) {
    ...ChatMessage
  }
}
    ${ChatMessageFragmentDoc}`;
export type SendMessageMutationFn = Apollo.MutationFunction<
  SendMessageMutation,
  SendMessageMutationVariables
>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(
    SendMessageDocument,
    options,
  );
}
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<
  SendMessageMutation,
  SendMessageMutationVariables
>;
